


























































import { Component, Vue } from "vue-property-decorator";
import CardIcon from "./CardIcon.vue";
import {GaHelper} from "@/core/helpers/ga";

@Component({ components: { CardIcon } })
export default class BadEnd extends Vue {
    mounted(){
        GaHelper.send("issue/allrejec")
    }
}
